import { generateAPI } from "../api.generator";

export type WeddingPlanStatus = "todo" | "in_progress" | "waiting_on_couple" | "waiting_on_planner" | "waiting_on_vendor" | "ready_for_approval" | "blocked" | "done";

export type WeddingPlanItem = {
  _id: string;
  title: string;
  description?: string;
  status: WeddingPlanStatus;
  priority: string;
  category?: string;
  assigneeKind?: "couple" | "planner" | "partner_one" | "partner_two";
  dueAt?: string;
  updatedAt: string;
};

export type WeddingPlanInput = Partial<Omit<WeddingPlanItem, "_id" | "updatedAt">>;

export const getWeddingPlan = generateAPI<object, WeddingPlanItem[]>("get", "planner/wedding-plan");
export const createWeddingPlanItem = generateAPI<{ body: WeddingPlanInput }, WeddingPlanItem>("post", "planner/wedding-plan");
export const updateWeddingPlanItem = (id: string) => generateAPI<{ body: WeddingPlanInput }, WeddingPlanItem>("put", `planner/wedding-plan/${id}`);
export const deleteWeddingPlanItem = (id: string) => generateAPI<object, { _id: string }>("delete", `planner/wedding-plan/${id}`);
